import { useEffect, useState } from 'react';
import {
    Form,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Input
} from 'reactstrap';

import InputMask from 'react-input-mask';

interface DataTypes {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    displayName: string;
}
interface EditContactModalProps {
    isOpen: boolean;
    onClose: () => void;
    onEdit: (data: any) => void;
    chatUserDetails: any;
}
const EditContactModal = ({
    isOpen,
    onClose,
    onEdit,
    chatUserDetails
}: EditContactModalProps) => {
    /* data input handeling */
    const [data, setData] = useState<DataTypes>({
        firstName: '',
        lastName: '',
        phoneNumber: '',
        displayName: ''
    });
    useEffect(() => {
        setData({
            firstName: chatUserDetails.firstName,
            lastName: chatUserDetails.lastName,
            phoneNumber: chatUserDetails.phoneNumber,
            displayName:
                chatUserDetails.displayName ||
                `${chatUserDetails.firstName} ${chatUserDetails.lastName}`
        });
    }, [chatUserDetails]);

    const onChangeData = (
        field: 'firstName' | 'lastName' | 'phoneNumber' | 'displayName',
        value: string
    ) => {
        let modifiedData: DataTypes = { ...data };
        if (value === '') {
            modifiedData[field] = '';
        } else if (field === 'phoneNumber') {
            modifiedData[field] = `+${value.replace(/\D/g, '')}`;
        } else {
            modifiedData[field] = value;
        }
        setData(modifiedData);
    };

    /* validation */
    const [valid, setValid] = useState<boolean>(false);
    useEffect(() => {
        if (
            data.firstName !== undefined &&
            data.lastName !== undefined &&
            data.phoneNumber !== undefined &&
            data.displayName !== undefined
        ) {
            setValid(true);
        } else {
            setValid(false);
        }
    }, [data]);

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
            tabIndex={-1}
            centered
            scrollable
        >
            <ModalHeader toggle={onClose} className="bg-primary">
                <div className="modal-title-custom text-white font-size-16 ">
                    Edit Contact
                </div>
            </ModalHeader>
            <ModalBody className="p-4">
                <Form>
                    <div className="mb-3">
                        <Label
                            htmlFor="EditContactModalfirstName-input"
                            className="form-label"
                        >
                            First Name
                        </Label>
                        <Input
                            type="text"
                            className="form-control"
                            id="EditContactModalfirstName-input"
                            placeholder="Enter First Name"
                            value={data['firstName'] || ''}
                            onChange={(e: any) => {
                                onChangeData('firstName', e.target.value);
                            }}
                        />
                    </div>
                    <div className="mb-3">
                        <Label
                            htmlFor="EditContactModallastName-input"
                            className="form-label"
                        >
                            Last Name
                        </Label>
                        <Input
                            type="text"
                            className="form-control"
                            id="EditContactModallastName-input"
                            placeholder="Enter Last Name"
                            value={data['lastName'] || ''}
                            onChange={(e: any) => {
                                onChangeData('lastName', e.target.value);
                            }}
                        />
                    </div>
                    <div className="mb-3">
                        <Label
                            htmlFor="EditContactModalphoneNumber-input"
                            className="form-label"
                        >
                            Phone Number
                        </Label>
                        <InputMask
                            className="form-control"
                            mask="+1 (999) 999-9999"
                            maskChar={''}
                            placeholder="Enter phone number"
                            value={data['phoneNumber'] || ''}
                            onChange={(e: any) => {
                                onChangeData('phoneNumber', e.target.value);
                            }}
                            alwaysShowMask={false}
                        />
                    </div>
                    <div className="mb-3">
                        <Label
                            htmlFor="EditContactModaldisplayName-input"
                            className="form-label"
                        >
                            Display Name
                        </Label>
                        <Input
                            type="text"
                            className="form-control"
                            id="EditContactModaldisplayName-input"
                            placeholder="Enter Alias"
                            value={data['displayName'] || ''}
                            onChange={(e: any) => {
                                onChangeData('displayName', e.target.value);
                            }}
                        />
                    </div>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button
                    type="button"
                    color="link"
                    className="btn"
                    onClick={onClose}
                >
                    Close
                </Button>
                <Button
                    type="button"
                    color="primary"
                    disabled={!valid}
                    onClick={() => onEdit(data)}
                >
                    Edit
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default EditContactModal;
